import React from "react";
import {
    ListExpensesContainer,
    ListExpensesContainerHeader,
    ListExpensesWrapp,
} from "./styles";
import { Strong } from "../../settings/layout";
import IExpense from "../../interfaces/IExpense";
import Expense from "../Expense";

interface IProps {
    title: string;
    items: IExpense[];
}

const ListExpenses = ({ title, items }: IProps) => (
    <ListExpensesContainer>
        {/* <ListExpensesContainerHeader>
            <Strong>{title}</Strong>
        </ListExpensesContainerHeader> */}

        <ListExpensesWrapp>
            {items.map((item) => (
                <Expense key={item.uuid} {...item} />
            ))}
        </ListExpensesWrapp>
    </ListExpensesContainer>
);

export default ListExpenses;
